import React from 'react'
import { Accordion as MuiAccordion, AccordionDetails, AccordionSummary, Tooltip, Typography, AccordionActions } from '@mui/material'
import { accordionSummaryClasses } from '@mui/material/AccordionSummary'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown } from '@fortawesome/pro-regular-svg-icons'

export const Accordion = ({
  title, icon,
  DetailsProps, children, actions,
  elevation = 1, expanded, ...props
}) => (
  <MuiAccordion
    expanded={expanded}
    elevation={elevation}
    {...props}
  >
    <Tooltip title={`${expanded ? 'Collapse' : 'Expand'} ${title}`}>
      <AccordionSummary
        expandIcon={<FontAwesomeIcon icon={faAngleDown} />}
        aria-controls={title || 'accordion'}
        sx={{
          minHeight: '2rem',
          backgroundColor: 'primary.50',
          [`&.${accordionSummaryClasses.content}.Mui-expanded`]: {
            my: 1.5
          },
          '&.Mui-expanded': {
            minHeight: '2rem',

          }
        }}
      >
        {!!icon && <Typography mr={1} color='primary'>
          {icon?.hasOwnProperty('icon')
            ? <FontAwesomeIcon icon={icon} />
            : icon
          }
        </Typography>}
        <Typography variant="h6" color='primary'>
          {title}
        </Typography>
      </AccordionSummary>
    </Tooltip>
    <AccordionDetails {...DetailsProps}>
      {children}
    </AccordionDetails>
    {actions && <AccordionActions>
      {actions}
    </AccordionActions>}
  </MuiAccordion>
)